import AxiosInterceptor from 'api/interceptor';
import fx from "../../utils/fx";

const templates = new AxiosInterceptor();

export default {
    update(id, inputs){
        return templates.put('/templates/'+ id, inputs);
    },
    get(inputs = {}){
        inputs = fx.urlQueryString(inputs, false);
        return templates.get('/templates?'+ inputs);
    },
    create(inputs) {
        return templates.post('/templates', inputs);
    },
      getHtml(inputs){
        return templates.get('/page-builder/parse-to-html?post_id='+ inputs);
    },
    getShortcode(inputs){
        return templates.get('/page-builder/parse-to-short-code?post_id='+ inputs);
    },
    htmlToShortCode(inputs){
        return templates.put('/page-builder/change-content-post', inputs);
    },
};